import React, { useState } from "react";
import Checkbox from "components/Auth/atoms/forms/CheckboxCostum";
import PrinterIconBlue from 'assets/images/printer_104203_1_blue.svg';

import i18n from "i18n";
import styles from "./PrinterModal.module.scss";

const PrinterModal = ({
  printers,
  devicePrinters,
  associatedPrinters,
  onClose,
  onSave
}) => {
  const [selectedDevices, setSelectedDevices] = useState(
    associatedPrinters.map(device => device.device)
  );

  const handleCheckboxChange = (deviceId, isAssociated) => {
    if (isAssociated) return; // No permitir desmarcar dispositivos asociados
    setSelectedDevices(prev =>
      prev.includes(deviceId)
        ? prev.filter(id => id !== deviceId)
        : [...prev, deviceId]
    );
  };

  return (
    <div className={styles["printer-modal"]}>
      <div className={styles["printer-modal-content"]}>
        <div className={styles["printer-modal-header"]}>
          <h4>
            <span className={styles["icon-container"]}>
              <img src={PrinterIconBlue} alt="printer icon" className={styles["printer-icon"]} />
            </span>
            <span className={styles["icon-container-title"]}>{i18n.t("associate.printer")}</span>
          </h4>
        </div>
        <div className={styles["printer-list"]}>
          {printers.map(printer => {
            const isAssociated = associatedPrinters.some(
              associated => associated.device === printer.option
            );
            return (
              <div key={printer.id} className={styles["printer-item"]}>
                <Checkbox
                  handleChange={() =>
                    handleCheckboxChange(printer.option, isAssociated)
                  }
                  checked={
                    isAssociated || selectedDevices.includes(printer.option)
                  }
                  disabled={isAssociated}
                  label={printer.label}
                ></Checkbox>
              </div>
            );
          })}
        </div>
        <div className={styles["modal-actions"]}>
          <button type="button" className={styles["cancel-button"]} onClick={onClose}>
            {i18n.t("cancel").toUpperCase()}
          </button>
          <button
            type="button"
            className={styles["save-button"]}
            onClick={() => onSave(selectedDevices)}
          >
            {i18n.t("save").toUpperCase()}
          </button>
        </div>
      </div>
    </div>
  );
};

export default PrinterModal;
